<template>
    <!-- 选择框 待完成-->
    <div class="dropdown-select-box" >
        <div class="dropdown-title">{{title}}</div>
        <div class="dropdown-select" >
          <van-field :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')" v-model="fieldValue" is-link arrow-direction="down" :disabled="disabled"  readonly @click="showPickerAction" autosize/>
          <van-popup v-model="showPicker" position="bottom" v-if="showPicker">
            <van-picker
              show-toolbar
              :confirm-button-text="$t('T_CONFIRM')"
              :cancel-button-text="$t('T_CANCEL')"
              :columns="selectData"
              :default-index="index"
              :value-key="label"
              @cancel="onCancel"
              @confirm="onConfirm"
            />
          </van-popup>
        </div>
    </div>
</template>

<script>
export default {
  name: 'dropdown',
  data () {
    return {
      showPicker: false,
      fieldValue: '',
      index: 1
    }
  },

  props: {
    title: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    selectData: {
      type: Array,
      default: () => {}
    },

    label: {
      type: String,
      default: 'key' // options 展示
    },

    valuekey: {
      type: String,
      default: 'value'
    },

    value: {
      default: ''
    }
  },

  model: {
    prop: 'value',
    event: 'on-picker-change'
  },
  watch: {
    value () {
      if (this.selectData !== '- - -' && this.value !== '- - -') {
        this.index = (this.selectData || []).findIndex(item => { return item[this.valuekey] === this.value })
        if (this.selectData[this.index]) {
          this.fieldValue = this.selectData[this.index][this.label]
        }
      } else {
        this.index = 0
        this.fieldValue = this.value
      }
    },
    showPicker (val) {
      if (document.querySelector('.van-popup--right') != null) {
        if (val) {
          document.querySelector('.van-popup--right .appContent').style.overflow = 'hidden'
        } else {
          document.querySelector('.van-popup--right .appContent').style.overflow = 'auto'
        }
      }
    },

    local (newVal) {
      if (this.selectData[0] && this.selectData[0].globalKey) {
        this.selectData.forEach(item => {
          item.label = this.$t(item.globalKey)
        })
        this.fieldValue = this.selectData[this.index][this.label]
      }
    }
  },
  mounted () {
    if (this.selectData) {
      this.index = this.selectData.findIndex(item => { return item[this.valuekey] === this.value })
      if (this.index > -1) {
        this.fieldValue = this.selectData[this.index][this.label]
      }
    } else {
      this.index = 0
      this.fieldValue = this.value
    }
  },

  methods: {
    onConfirm (value) {
      this.fieldValue = value[this.label]
      this.$emit('on-picker-change', value[this.valuekey])
      this.$emit('change', value[this.valuekey])
      this.showPicker = false
    },
    showPickerAction () {
      if (this.disabled === false && this.selectData !== null) {
        this.showPicker = true
      }
    },
    onCancel () {
      this.showPicker = false
    }
  },

  computed: {
    local () {
      return this.$i18n.locale
    }
  }

}
</script>

<style scoped>
  .van-cell:not(:last-child)::after{
    border-bottom:0
  }
  .van-picker__cancel, .van-picker__confirm{
    color: #10218b !important
  }
  .dropdown-title{
    font-weight: normal
  }

</style>
